import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const textVariants = cva(
  "font-sans [font-variation-settings:'wdth'_115.4]",
  {
    variants: {
      variant: {
        xl: "text-xl font-normal",
        lg: "text-lg font-normal",
        md: "text-base font-normal",
        sm: "text-sm font-normal",
        xs: "text-xs font-normal",
      },
    },
    defaultVariants: {
      variant: "md",
    },
  }
)

export interface TextProps
  extends React.HTMLAttributes<HTMLElement>,
    VariantProps<typeof textVariants> {
  as?: "p" | "span" | "div" | "label"
}

function Text({
  className,
  variant = "md",
  as,
  ...props
}: TextProps) {
  const Component = as || "p"

  return (
    <Component
      className={cn(textVariants({ variant, className }))}
      {...props}
    />
  )
}

export { Text, textVariants }
